module.exports = __webpack_public_path__ + "static/media/cms11.6a735dab.png";